
if(typeof window === 'object' && typeof window.lazySizesConfig !== 'object') {
  window.lazySizesConfig = {};
  window.lazySizesConfig.loadHidden = false; //disable loading visibility: hidden elements
  window.lazySizesConfig.loadMode = 1; //only load visible elements

  // add support for background images using data-bg
  document.addEventListener('lazybeforeunveil', function(e){
    const bg = e.target.getAttribute('data-bg');
    if(bg){
      e.target.style.backgroundImage = `url("${bg}")`;
    }
  });

  require('lazysizes');
  require('lazysizes/plugins/attrchange/ls.attrchange');
}
